import { CheckCircleFilled, CloseCircleFilled, LoadingOutlined } from '@ant-design/icons';
import { Spin } from 'antd';
import { colorConstants } from 'config/colorConstants';
import { ReactNode } from 'react';

export type OptimizationStatusType = {
    status: 'completed' | 'in_progress' | 'error' | null;
    message: string | null;
    title: string | null;
};

const LOADING_ICON_STYLE = { fontSize: 18, color: colorConstants.cyan };
const CHECK_ICON_STYLE = { position: 'relative' as const, top: -3, fontSize: 16 };
const ERROR_ICON_STYLE = { position: 'relative' as const, fontSize: 16, top: -3, color: '#FF4D4F' };

export const getOptimizationStatusIconColor = (statusTitle: string | null | undefined): string => {
    if (!statusTitle) {
        return colorConstants.limeGreen;
    }

    const title = statusTitle.toLowerCase();
    switch (title) {
        case 'optimal solution found':
            return colorConstants.limeGreen;
        case 'solution found':
            return colorConstants.yellowAlt;
        case 'no solution exists':
            return colorConstants.fontGreyAlt;
        default:
            return colorConstants.limeGreen;
    }
};

export const getOptimizationStatusIcon = (status: OptimizationStatusType | null | undefined): ReactNode => {
    if (!status?.status) {
        return null;
    }

    const { status: statusValue, title } = status;

    switch (statusValue) {
        case 'in_progress':
            return <Spin indicator={<LoadingOutlined style={LOADING_ICON_STYLE} spin />} />;
        case 'error':
            return <CloseCircleFilled style={ERROR_ICON_STYLE} />;
        case 'completed': {
            const iconColor = getOptimizationStatusIconColor(title);
            return <CheckCircleFilled style={{ ...CHECK_ICON_STYLE, color: iconColor }} />;
        }
        default:
            return null;
    }
};
